import {
  DATA_CLIENT_STATUS,
  DATA_RPQ_STATUS,
  DATA_ORDER_STATUS,
  DATA_DN_STATUS,
  DATA_DN_PAYMENT_STATUS,
  DATA_PRODUCT_STATUS,
  DATA_USER_DISPOSAL_STATUS,
  DATA_ORDER_SERVICE_STATUS,
} from "./options";

const RENEWAL_STATUS_OPTIONS = [
  { value: "", label: "(None)" },
  { value: "PENDING", label: "Pending" },
  { value: "WAIT", label: "Wait to confirm" },
  { value: "CONFIRM", label: "Confirmed" },
  { value: "RENEWED", label: "Renewed" },
  { value: "TERMINATED", label: "Terminated" },
];

const POLICY_STATUS_OPTIONS = [
  { value: "NONE", label: "None" },
  { value: "POLICY_RECEIVED", label: "Policy Received" },
  { value: "POLICY_DISPATCHED", label: "Policy Dispatched" },
];

const USER_STATUS_OPTIONS = [
  { value: "DFT", label: "Draft" },
  { value: "PENDING", label: "Pending" },
  { value: "ACTIVE", label: "Active" },
  { value: "INACTIVE", label: "Inactive" },
  { value: "TERMINATED", label: "Terminated" },
];

const QUIZ_STATUS_OPTIONS = [
  { value: "DFT", label: "Draft" },
  { value: "DRAFT", label: "Draft (legacy)" },
  { value: "ACTIVE", label: "Active" },
  { value: "CLOSED", label: "Closed" },
];

export const MCA_ENTITIES = [
  {
    value: "client",
    label: "Client",
    watchFields: [
      "age",
      "annualIncome",
      "accountCloseDate",
      "birthday",
      "bussinessNature",
      "cname",
      "code",
      "consultants",
      "contactPerson",
      "currentAssets",
      "currentAssetsCurrency",
      "educationLevel",
      "email",
      "fax",
      "gender",
      "givenName",
      "id",
      "idDocExpiryDate",
      "identity.hkbr",
      "identity.hkid",
      "identity.passport",
      "identity.staffNo",
      "identityExpired",
      "idIssueCountry",
      "idType",
      "industry",
      "isTransfer",
      "language",
      "mailType",
      "marketingPreference",
      "maritalStatus",
      "name",
      "nationality",
      "occupation",
      "parentCompany",
      "pep.isPep",
      "pep.remark",
      "phone",
      "phone2",
      "piAnnualConfirmationDate",
      "piEffectiveDate",
      "piExpirationReminderDate",
      "piTerminationDate",
      "placeOfBirth",
      "professionalInvestor",
      "knowledgeOfDerivatives",
      "remark",
      "residentialCountry",
      "salaryPayRatio",
      "salutation",
      "status",
      "rpqStatus",
      "surname",
      "type",
      "vulnerable",
      "yearlySalary",
      "lineOfBusiness",
      "requiresCdd",
      "eddRequired",
      "complianceReviewRequired",
    ],
    setValueFields: [
      { field: "status", label: "Status", options: DATA_CLIENT_STATUS },
      { field: "rpqStatus", label: "RPQ Status", options: DATA_RPQ_STATUS },
    ],
  },
  {
    value: "order",
    label: "Order",
    watchFields: [
      "aipAt",
      "applicationMethod",
      "basicOrder",
      "bidConsultants",
      "client",
      "commissionSetting",
      "consultants",
      "createdBy",
      "dateBackOption",
      "debitNote",
      "forceUncertainPayment",
      "fnaSignDate",
      "handlerBy",
      "handlerBy2",
      "insuredAge",
      "isCertainPayment",
      "isGI",
      "isRider",
      "isSplit",
      "lapsedSurrenderDate",
      "mainlandChineseVisitor",
      "mpfAccountType",
      "payment.actualYearRate",
      "payment.creditCardLast4",
      "payment.currency",
      "payment.initialPayment",
      "payment.initialPaymentCurrency",
      "payment.levy",
      "payment.maturityDate",
      "payment.payBy",
      "payment.payCount",
      "payment.payMode",
      "payment.payStatus",
      "payment.paymentTerm",
      "payment.paymentTermUntilAge",
      "payment.payUpDate",
      "payment.policyTerm",
      "payment.preliminaryDate",
      "payment.prePayment",
      "payment.prePaymentCurrency",
      "payment.premium",
      "payment.renewalPayBy",
      "payment.sumInsured",
      "payment.yearCommission",
      "payment.yearConsultant1Commission",
      "payment.yearConsultant2Commission",
      "payment.yearConsultantCommission",
      "payment.yearPremium",
      "payment.yearRate",
      "policyAckSignDate",
      "policyCommenceDate",
      "policyCoolingOffDate",
      "policyDeliverDate",
      "policyDeliverMethod",
      "policyDeliverRemark",
      "policyDocumentType",
      "policyIssueDate",
      "policyNumber",
      "policyRemark",
      "policyReplacement",
      "premiumFinancing",
      "product",
      "productCategory",
      "productType",
      "professionalInvestor",
      "provider",
      "receivedDate",
      "reinstateDate",
      "remark",
      "renewalCount",
      "renewalStatus",
      "signedBy",
      "signedBy2",
      "signedDate",
      "signedPlace",
      "status",
      "submissionDate",
      "taxable",
      "totalWithdrawalAmount",
      "transferInEffectiveDate",
      "transferOutDate",
      "type",
      "lineOfBusiness",
      "requiresCdd",
      "eddRequired",
      "complianceReviewRequired",
    ],
    setValueFields: [
      { field: "status", label: "Status", options: DATA_ORDER_STATUS },
      { field: "renewalStatus", label: "Renewal Status", options: RENEWAL_STATUS_OPTIONS },
    ],
  },
  {
    value: "debitNote",
    label: "Debit Note",
    watchFields: [
      "client",
      "clientFixRate",
      "clientType",
      "code",
      "commissionRate",
      "confirmedAt",
      "consultants",
      "costTotal",
      "createdBy",
      "currency",
      "date",
      "discountAmount",
      "forceRenewal",
      "holdCover.date",
      "holdCover.remark",
      "insuredValue",
      "mortgageeHirePurchaseName",
      "mortgageePostalAddress",
      "mortgagePostDate",
      "order",
      "parentCompany",
      "payment.amount",
      "payment.adjustmentAmount",
      "payment.totalByCredit",
      "paymentStatus",
      "period.end",
      "period.start",
      "policyDispatchedAt",
      "policyNumber",
      "policyReceivedAt",
      "policyStatus",
      "product",
      "productType",
      "profit",
      "provider",
      "providerCostReference",
      "providerFixRate",
      "refNo",
      "remark",
      "renewalCount",
      "renewalStatus",
      "settledAt",
      "settlement.amount",
      "settlement.paymentMethod",
      "settlement.remark",
      "settlement.settleDate",
      "signedBy",
      "signedBy2",
      "status",
      "taxable",
      "to",
      "total",
      "type",
    ],
    setValueFields: [
      { field: "status", label: "Status", options: DATA_DN_STATUS },
      { field: "paymentStatus", label: "Payment Status", options: DATA_DN_PAYMENT_STATUS },
      { field: "policyStatus", label: "Policy Status", options: POLICY_STATUS_OPTIONS },
      { field: "renewalStatus", label: "Renewal Status", options: RENEWAL_STATUS_OPTIONS },
    ],
  },
  {
    value: "user",
    label: "User",
    watchFields: [
      "address",
      "aliasName",
      "birthday",
      "cname",
      "consultantInfo.iaApplyDate",
      "consultantInfo.iaEffectiveDate",
      "consultantInfo.iaFirstRegisterDate",
      "consultantInfo.iaNumber",
      "consultantInfo.iaRole",
      "consultantInfo.iaTerminationDate",
      "consultantInfo.mpfaApplyDate",
      "consultantInfo.mpfaEffectiveDate",
      "consultantInfo.mpfaFirstRegisterDate",
      "consultantInfo.mpfaNumber",
      "consultantInfo.mpfaRole",
      "consultantInfo.mpfaTerminationDate",
      "consultantInfo.overridingPlan",
      "consultantInfo.paymentMethods.accNumber",
      "consultantInfo.paymentMethods.bank",
      "consultantInfo.paymentMethods.name",
      "consultantInfo.paymentMethods.type",
      "consultantInfo.sfcApplyDate",
      "consultantInfo.sfcEffectiveDate",
      "consultantInfo.sfcFirstRegisterDate",
      "consultantInfo.sfcNumber",
      "consultantInfo.sfcRole",
      "department",
      "disableCreateOrder",
      "disposalStatus",
      "educationLevel",
      "email",
      "emails",
      "addresses",
      "emergencyContact",
      "emergencyContactNo",
      "employmentDate",
      "gender",
      "givenName",
      "hkid",
      "idIssueCountry",
      "idType",
      "isActive",
      "isConsultant",
      "mariage",
      "name",
      "nationality",
      "parent",
      "personalEmail",
      "phone",
      "phones",
      "phone2",
      "referedBy",
      "staffId",
      "status",
      "surname",
      "teams",
      "termination.effectiveDate",
      "termination.lastEmploymentDate",
      "termination.reason",
      "termination.resignDate",
      "userCategory",
      "userRole",
      "userType",
      "wallet",
      "workTitle",
    ],
    setValueFields: [
      { field: "status", label: "Status", options: USER_STATUS_OPTIONS },
      {
        field: "disposalStatus",
        label: "Disposal Status",
        options: DATA_USER_DISPOSAL_STATUS,
      },
    ],
  },
  {
    value: "quiz",
    label: "Quiz",
    watchFields: [
      "body",
      "code",
      "createdBy",
      "deadline",
      "maxRetakeCount",
      "noLicenceNeed",
      "passingRate",
      "requiredLicenses",
      "requiredSfcLicences",
      "startDate",
      "status",
      "targetRole",
      "testDuration",
      "title",
    ],
    setValueFields: [{ field: "status", label: "Status", options: QUIZ_STATUS_OPTIONS }],
  },
  {
    value: "product",
    label: "Product",
    watchFields: [
      "activeTable",
      "ageType",
      "allowOffShore",
      "allowPreimumFinancing",
      "allowPrepaid",
      "category",
      "cname",
      "code",
      "currency",
      "description",
      "inactiveSince",
      "insuredWeeklyAge",
      "isActive",
      "jurisdiction",
      "minInitialCharge",
      "minInsured",
      "minPremium",
      "name",
      "otherName",
      "payModes",
      "payTermMax",
      "payTermMin",
      "planCode",
      "policyPledege",
      "popularity",
      "provider",
      "scname",
      "status",
      "type",
    ],
    setValueFields: [{ field: "status", label: "Status", options: DATA_PRODUCT_STATUS }],
  },
  {
    value: "provider",
    label: "Provider",
    watchFields: [
      "address",
      "ageType",
      "cname",
      "code",
      "email",
      "fax",
      "insurerCode",
      "isActive",
      "name",
      "paymentInfo",
      "productCategories",
      "remark",
      "shortName",
      "tel",
      "website",
    ],
    setValueFields: [],
  },
  {
    value: "productType",
    label: "Product Type",
    watchFields: [
      "allowQuoRequest",
      "category",
      "cname",
      "code",
      "groupCode",
      "groupName",
      "investmentTransactions",
      "mortgageeHirePurchase",
      "levySettings.ecLevy.formulaType",
      "levySettings.ecLevy.required",
      "levySettings.iaLevy.required",
      "levySettings.mibLevy.required",
      "name",
      "renewable",
    ],
    setValueFields: [],
  },
  {
    value: "cpd",
    label: "CPD Record",
    watchFields: ["passApproval", "courseTitle", "courseCode", "consultant"],
    setValueFields: [{ field: "passApproval", label: "Approved" }],
  },
  {
    value: "orderInvestmentTransaction",
    label: "Investment Transaction",
    watchFields: ["orderId", "status", "ifastTransactionNo", "complianceReviewRequired"],
    setValueFields: [{ field: "status", label: "Status" }],
  },
  {
    value: "commissionSchedule",
    label: "Commission Schedule",
    watchFields: ["effectiveDate", "endDate", "status", "remark"],
    setValueFields: [{ field: "status", label: "Status" }],
  },
  {
    value: "commissionRelease",
    label: "Commission Release",
    watchFields: ["payroll", "consultant", "totalAmount", "bidIds"],
    setValueFields: [{ field: "status", label: "Status" }],
  },
  {
    value: "clientTransfer",
    label: "Client Transfer",
    watchFields: [
      "fromConsultant",
      "toConsultant",
      "clientIds",
      "transferBidOwnership",
    ],
    setValueFields: [{ field: "status", label: "Status" }],
  },
  {
    value: "productDueDiligence",
    label: "Product Due Diligence",
    watchFields: ["product", "reviewType", "dueDate", "status"],
    setValueFields: [{ field: "status", label: "Status" }],
  },
  {
    value: "personalTradingDeclaration",
    label: "Personal Trading Declaration",
    watchFields: ["consultant", "declarationDate", "status", "files"],
    setValueFields: [{ field: "status", label: "Status" }],
  },
  {
    value: "orderService",
    label: "Order Service",
    watchFields: [
      "serviceType",
      "serviceTypeSnapShot.code",
      "serviceTypeCode",
      "status",
      "orderId",
      "description",
    ],
    setValueFields: [
      { field: "status", label: "Status", options: DATA_ORDER_SERVICE_STATUS },
    ],
  },
  {
    value: "approval",
    label: "Approval",
    apiEntity: "mcaProcess",
    watchFields: [
      "name",
      "cname",
      "description",
      "status",
      "priority",
      "triggerType",
      "triggerConfig.targetEntity",
      "triggerConfig.action",
      "triggerConfig.watchFields",
      "triggerConfig.allowedMakers",
      "triggerConfig.allowedMakerRoles",
      "steps",
    ],
    setValueFields: [
      {
        field: "status",
        label: "Status",
        options: [
          { value: "DFT", label: "Draft" },
          { value: "ACTIVE", label: "Active" },
          { value: "INACTIVE", label: "Inactive" },
        ],
      },
    ],
  },
];

export const MCA_WATCH_FIELD_LOGIC = [
  { value: "OR", label: "Any condition matches (OR)" },
  { value: "AND", label: "All conditions must match (AND)" },
];

export const MCA_ACTIONS = [
  { value: "CREATE", label: "Create" },
  { value: "UPDATE", label: "Update" },
  { value: "DELETE", label: "Delete" },
];

export const MCA_TRIGGER_TYPES = [
  { value: "HOOK", label: "Automatic (Hook)" },
  { value: "MANUAL", label: "Manual" },
];

export const MCA_APPROVAL_TYPES = [
  { value: "ANY", label: "Any one approver" },
  { value: "ALL", label: "All approvers must approve" },
];

export const MCA_ROUTING_ACTION_TYPES = [
  { value: "GO_TO_STEP", label: "Go to step" },
  { value: "FINISH", label: "Direct Approve" },
];

export const MCA_BUTTON_COLORS = [
  { value: "blue", label: "Blue" },
  { value: "teal", label: "Teal" },
  { value: "green", label: "Green" },
  { value: "cyan", label: "Cyan" },
  { value: "indigo", label: "Indigo" },
  { value: "orange", label: "Orange" },
  { value: "yellow", label: "Yellow" },
  { value: "red", label: "Red" },
  { value: "pink", label: "Pink" },
  { value: "dark", label: "Black" },
];

export const DEFAULT_ROUTING_ACTION_COLOR = {
  GO_TO_STEP: "blue",
  FINISH: "teal",
};

export const defaultRoutingAction = (type = "GO_TO_STEP") => ({
  type,
  label: "",
  cname: "",
  color: DEFAULT_ROUTING_ACTION_COLOR[type] ?? "blue",
  targetStepOrder: null,
});

export const CONDITION_TYPES = [
  { value: "$eq", label: "Equals" },
  { value: "$in", label: "In list" },
  { value: "$gt", label: "Greater than" },
  { value: "$gte", label: "Greater or equal" },
  { value: "$lt", label: "Less than" },
  { value: "$lte", label: "Less or equal" },
];

export const getEntityLabel = (value) =>
  MCA_ENTITIES.find((e) => e.value === value)?.label ?? value;

export const getEntitySetValueFields = (entityValue) =>
  MCA_ENTITIES.find((e) => e.value === entityValue)?.setValueFields ?? [];

export const MCA_NOTIFY_BY = [
  { value: "EMAILS", label: "Emails" },
  { value: "USERS", label: "Users" },
  { value: "USER_ROLE", label: "User Role" },
];

export const MCA_NOTIFY_CHANNELS = [
  { value: "EMAIL", label: "Email" },
  { value: "SMS", label: "SMS" },
];

export const MCA_NOTIFICATION_TEMPLATE_VARS = [
  { value: "requestCode", label: "Request code", token: "{{requestCode}}" },
  { value: "stepName", label: "Step name", token: "{{stepName}}" },
  { value: "entityCode", label: "Entity code", token: "{{entityCode}}" },
  { value: "actorName", label: "Actor name", token: "{{actorName}}" },
  { value: "trigger", label: "Trigger (START / COMPLETE)", token: "{{trigger}}" },
];

const USER_PASSWORD_TEMPLATE_VAR = {
  value: "userPassword",
  label: "User password",
  token: "{{userPassword}}",
};

export const getMcaNotificationTemplateVars = (targetEntity) => {
  if (targetEntity === "user") {
    return [...MCA_NOTIFICATION_TEMPLATE_VARS, USER_PASSWORD_TEMPLATE_VAR];
  }
  return MCA_NOTIFICATION_TEMPLATE_VARS;
};

export const defaultStepNotification = () => ({
  name: "",
  channel: "EMAIL",
  notifyOnStart: false,
  notifyOnComplete: true,
  notifyBy: "USERS",
  notifyEmails: [],
  notifyUsers: [],
  notifyRoles: [],
  notifyMaker: false,
  notifyNextApprovers: false,
  notifyEntityUser: false,
  notifyEntityClient: false,
  notifyEntityConsultants: false,
  subject: "",
  message: "",
});

export const validateStepNotification = (notification) => {
  if (!notification.name?.trim()) {
    return "Name is required";
  }
  if (!notification.notifyOnStart && notification.notifyOnComplete === false) {
    return "Select at least one trigger (step start or complete)";
  }
  const by = notification.notifyBy ?? "USERS";
  const hasPrimary =
    (by === "EMAILS" && (notification.notifyEmails ?? []).length > 0) ||
    (by === "USERS" && (notification.notifyUsers ?? []).length > 0) ||
    (by === "USER_ROLE" && (notification.notifyRoles ?? []).length > 0);
  const hasAdditional =
    notification.notifyMaker ||
    notification.notifyNextApprovers ||
    notification.notifyEntityUser ||
    notification.notifyEntityClient ||
    notification.notifyEntityConsultants;
  if (!hasPrimary && !hasAdditional) {
    return "Select at least one recipient";
  }
  if ((notification.channel ?? "EMAIL") === "EMAIL") {
    if (!notification.subject?.trim()) {
      return "Email subject is required";
    }
    if (!notification.message?.trim()) {
      return "Email message is required";
    }
  }
  return null;
};

const notifyByLabel = (value) =>
  MCA_NOTIFY_BY.find((o) => o.value === value)?.label ?? value;

export const summarizeNotificationRecipients = (notification) => {
  if (!notification) return "—";
  const parts = [];
  const by = notification.notifyBy ?? "USERS";
  if (by === "EMAILS") {
    const count = (notification.notifyEmails ?? []).length;
    parts.push(count ? `${count} email${count > 1 ? "s" : ""}` : "Emails");
  } else if (by === "USERS") {
    const count = (notification.notifyUsers ?? []).length;
    parts.push(count ? `${count} user${count > 1 ? "s" : ""}` : "Users");
  } else if (by === "USER_ROLE") {
    const count = (notification.notifyRoles ?? []).length;
    parts.push(count ? `${count} role${count > 1 ? "s" : ""}` : "User Role");
  }
  if (notification.notifyMaker) parts.push("Maker");
  if (notification.notifyNextApprovers) parts.push("Next approvers");
  if (notification.notifyEntityUser) parts.push("Entity user");
  if (notification.notifyEntityClient) parts.push("Entity client");
  if (notification.notifyEntityConsultants) parts.push("Entity consultants");
  return parts.length ? parts.join(", ") : notifyByLabel(by);
};

export const summarizeNotificationWhen = (notification) => {
  const parts = [];
  if (notification?.notifyOnStart) parts.push("Start");
  if (notification?.notifyOnComplete !== false) parts.push("Complete");
  return parts.length ? parts.join(", ") : "—";
};

export const MCA_STEP_FIELD_TYPES = [
  { value: "TEXT", label: "Text" },
  { value: "TEXTAREA", label: "Textarea" },
  { value: "INTEGER", label: "Integer" },
  { value: "DECIMAL_2", label: "Decimal (2)" },
  { value: "DECIMAL_4", label: "Decimal (4)" },
  { value: "DATE", label: "Date" },
  { value: "DATETIME", label: "Date & time" },
  { value: "SINGLE_FILE", label: "Single file" },
  { value: "MULTIPLE_FILES", label: "Multiple files" },
];

export const isFileFieldType = (inputType) =>
  inputType === "SINGLE_FILE" ||
  inputType === "MULTIPLE_FILES" ||
  inputType === "FILE";

export const isNumberFieldType = (inputType) =>
  inputType === "NUMBER" ||
  inputType === "INTEGER" ||
  inputType === "DECIMAL_2" ||
  inputType === "DECIMAL_4";

export const normalizeStepFieldInputType = (field) => {
  const inputType = field?.inputType ?? "TEXT";
  if (inputType === "FILE") {
    return field?.multiple ? "MULTIPLE_FILES" : "SINGLE_FILE";
  }
  if (inputType === "NUMBER") return "INTEGER";
  return inputType;
};

export const normalizeStepField = (field) => ({
  label: field.label ?? "",
  cname: field.cname ?? "",
  inputType: normalizeStepFieldInputType(field),
  required: !!field.required,
});

export const getStepFieldNumberPrecision = (field) => {
  const inputType = field?.inputType ?? "TEXT";
  if (inputType === "DECIMAL_2") return 2;
  if (inputType === "DECIMAL_4") return 4;
  return 0;
};

export const formatStaffLabel = (user) => {
  if (!user) return null;
  if (typeof user !== "object") return String(user);
  const staffId = user.staffId ?? "--";
  const name = user.name?.trim() ?? "";
  const cname = user.cname?.trim() ?? "";
  const aliasName = user.aliasName?.trim() ?? "";
  const nameParts = [];
  if (name) nameParts.push(name);
  if (cname && cname !== name) nameParts.push(cname);
  const namePart = nameParts.join(", ");
  const suffix =
    aliasName && aliasName !== name && aliasName !== cname
      ? namePart
        ? ` ${aliasName}`
        : aliasName
      : "";
  if (!namePart && !suffix) return `[${staffId}]`;
  return `[${staffId}] ${namePart}${suffix}`.trim();
};

export const formatStepFieldNumberValue = (value, precision = 0) => {
  if (value === null || value === undefined || value === "") return "—";
  const num = Number(value);
  if (Number.isNaN(num)) return String(value);
  return num.toLocaleString("en-US", {
    minimumFractionDigits: 0,
    maximumFractionDigits: precision,
  });
};

export const formatStepFieldLabel = (field) => {
  if (!field) return "";
  const en = field.label ?? "";
  const zh = field.cname?.trim();
  if (en && zh) return `${en} / ${zh}`;
  return en || zh || "";
};

export const formatStepFieldValue = (field) => {
  const value = field?.value;
  if (isFileFieldType(field?.inputType)) {
    const files = Array.isArray(value) ? value : [];
    if (!files.length) return "—";
    return files.map((f) => f.fileName).filter(Boolean).join(", ");
  }
  if (value === null || value === undefined || value === "") return "—";
  if (isNumberFieldType(field?.inputType)) {
    return formatStepFieldNumberValue(value, getStepFieldNumberPrecision(field));
  }
  if (field.inputType === "DATE" || field.inputType === "DATETIME") {
    const d = new Date(value);
    if (!Number.isNaN(d.getTime())) {
      return field.inputType === "DATETIME"
        ? d.toLocaleString()
        : d.toLocaleDateString();
    }
  }
  return String(value);
};

export const migrateStepFields = (step) => {
  let fields = [];
  if ((step?.stepFields ?? []).length > 0) {
    fields = step.stepFields.map(normalizeStepField);
  } else if (step?.requireComment) {
    fields = [
      {
        label: "Comment",
        cname: "備註",
        inputType: "TEXTAREA",
        required: true,
      },
    ];
  }
  for (const doc of step?.uploadDocuments ?? []) {
    const title = doc.title?.trim();
    if (!title) continue;
    fields.push({
      label: title,
      cname: "",
      inputType: "MULTIPLE_FILES",
      required: !!doc.required,
    });
  }
  return fields;
};

export const migrateStepNotifications = (step) => {
  if ((step?.notifications ?? []).length > 0) {
    return step.notifications.map((n) => ({
      ...defaultStepNotification(),
      ...n,
    }));
  }
  const legacy = step?.notification;
  if (!legacy) return [];
  const hasConfig =
    legacy.enabled ||
    legacy.notifyMaker ||
    legacy.notifyNextApprovers ||
    (legacy.notifyUsers ?? []).length > 0 ||
    (legacy.notifyRoles ?? []).length > 0 ||
    legacy.notifyOnStart ||
    legacy.subject ||
    legacy.message;
  if (!hasConfig) return [];

  let notifyBy = "USERS";
  if ((legacy.notifyRoles ?? []).length && !(legacy.notifyUsers ?? []).length) {
    notifyBy = "USER_ROLE";
  }

  return [
    {
      ...defaultStepNotification(),
      name: "Notification 1",
      channel: "EMAIL",
      notifyOnStart: !!legacy.notifyOnStart,
      notifyOnComplete: legacy.notifyOnComplete !== false,
      notifyBy,
      notifyEmails: [],
      notifyUsers: legacy.notifyUsers ?? [],
      notifyRoles: legacy.notifyRoles ?? [],
      notifyMaker: !!legacy.notifyMaker,
      notifyNextApprovers: !!legacy.notifyNextApprovers,
      notifyEntityUser: false,
      notifyEntityClient: false,
      notifyEntityConsultants: false,
      subject: legacy.subject ?? "",
      message: legacy.message ?? "",
    },
  ];
};
